import { readFileSync } from 'node:fs';
import { CliError, ExitCode } from '../../../lib/errors';

const MAX_MESSAGE = 2000;

export interface ApplyBatchItem {
	enc_job_id: string;
	enc_resume_id: string;
	application_message: string;
}

function defaultReadStdin(): string {
	return readFileSync(0, 'utf8');
}

function validateMessageText(raw: string): string {
	const trimmed = raw.trim();
	if (trimmed.length < 1) {
		throw new CliError('application message must not be empty (1~2000 chars) 應徵訊息必填', ExitCode.InvalidArgument);
	}
	if (trimmed.length > MAX_MESSAGE) {
		throw new CliError(`application message exceeds ${MAX_MESSAGE} chars 應徵訊息不可超過 2000 字`, ExitCode.InvalidArgument);
	}
	return trimmed;
}

/** 單筆 --message / --message-file 互斥二擇一必填;`-` 讀 stdin。違規丟 exit 2。 */
export function resolveMessage(opts: { message?: string; messageFile?: string; readStdin?: () => string }): string {
	const hasMsg = opts.message !== undefined;
	const hasFile = opts.messageFile !== undefined;
	if (hasMsg && hasFile) {
		throw new CliError('--message and --message-file are mutually exclusive 互斥', ExitCode.InvalidArgument);
	}
	if (!hasMsg && !hasFile) {
		throw new CliError('--message or --message-file is required 應徵訊息必填', ExitCode.InvalidArgument);
	}
	if (hasMsg) return validateMessageText(opts.message as string);
	const file = opts.messageFile as string;
	const raw = file === '-' ? (opts.readStdin ?? defaultReadStdin)() : readFileSync(file, 'utf8');
	return validateMessageText(raw);
}

/** 批次 ≤20 + 每筆欄位齊 + message 1~2000。違規丟 exit 2。回正規化(trim)後的項目。 */
export function validateBatchItems(items: unknown): ApplyBatchItem[] {
	if (!Array.isArray(items) || items.length < 1) {
		throw new CliError('batch file must contain a non-empty "applications" array', ExitCode.InvalidArgument);
	}
	if (items.length > 20) {
		throw new CliError(`batch exceeds 20 items (got ${items.length}) 批次上限 20 筆`, ExitCode.InvalidArgument);
	}
	return items.map((it, i) => {
		const o = it as Record<string, unknown>;
		const jobId = typeof o?.enc_job_id === 'string' ? o.enc_job_id.trim() : '';
		const resumeId = typeof o?.enc_resume_id === 'string' ? o.enc_resume_id.trim() : '';
		if (!jobId || !resumeId) {
			throw new CliError(`batch item #${i}: enc_job_id and enc_resume_id required`, ExitCode.InvalidArgument);
		}
		const message = validateMessageText(typeof o?.application_message === 'string' ? o.application_message : '');
		return { enc_job_id: jobId, enc_resume_id: resumeId, application_message: message };
	});
}
